
    import { trackEvent } from './analytics.js';
    trackEvent('page_view', { page: 'landing' });
  